<template>
<at-modal v-model="filter.show" title="Фильтр" okText="Применить" cancelText="Закрыть" :maskClosable="false" :styles="{width: '70%', minWidth: '300px', maxWidth: '520px'}" @on-confirm="$emit('filter-confirm')">
    <div style="width: calc(100% - 100px)">
        <p>
            <span style="font-size: smaller; color: #8a94a1;">Глубина:</span>
            <at-select v-model="filter.depth" style="width: 100%" on-change="$emit('filter-change')" multiple>
                <at-option v-for="depth in depths" :key="depth.id" :value="String(depth.id)">{{ depth.name }}</at-option>
            </at-select>
        </p>
        <p>
            <span style="font-size: smaller; color: #8a94a1;">Тип работ:</span>
            <at-select v-model="filter.works" style="width: 100%" on-change="$emit('filter-change')" multiple>
                <at-option v-for="work in works" :key="work.id" :value="work.id">{{ work.name }}</at-option>
            </at-select>
        </p>
        <p>
            <span style="font-size: smaller; color: #8a94a1;">Руководитель:</span>
            <at-select v-model="filter.manager" style="width: 100%" on-change="$emit('filter-change')" multiple>
                <at-option v-for="manager in managers" :key="manager.id" :value="manager.id">{{ manager.name }}</at-option>
            </at-select>
        </p>
    </div>
</at-modal>
</template>

<script>
export default {
    computed: {
        filter() {
            return this.$store.state.filter;
        },
        managers() {
            return this.$store.state.managers.data
        },
        depths() {
            return this.$store.state.depths.data
        },
        works() {
            return this.$store.state.works.data
        }
    }
};
</script>

<style scoped>

p {
    color: #3f536e;
    font-size: 14px;
    margin: 0;
    padding: 0;
}

</style>
